export default class PaymentRepository {
  constructor(paymentApiService, localStorageService, pricingSocketService) {
    if (new.target === PaymentRepository) {
      throw new Error("Cannot instantiate an abstract class.");
    }

    if (this.processSubscriptionPayment === PaymentRepository.prototype.processSubscriptionPayment) {
      throw new Error("Class extending PaymentRepository must override 'processSubscriptionPayment(data)'.");
    }

    if (this.processAddonPayment === PaymentRepository.prototype.processAddonPayment) {
      throw new Error("Class extending PaymentRepository must override 'processAddonPayment(data)'.");
    }

    this.paymentApiService = paymentApiService;
    this.localStorageService = localStorageService;
    this.pricingSocketService = pricingSocketService;
  }

  async processSubscriptionPayment(
    tierId,
    { cardHolderFirstName, cardHolderLastName, cardNumber, expiryDate, cvc },
    {
      billingAddressFirstName,
      billingAddressLastName,
      billingAddressEmail,
      billingAddressPhone,
      billingAddressAddressLine1,
      billingAddressCity,
      billingAddressState,
      billingAddressZipCode,
      billingAddressCountry,
    },
    { onSuccess, onError, onDone, onNoBillingAddress, onNoPaymentMethod }
  ) {
    throw new Error("Method 'processSubscriptionPayment(data)' must be implemented.");
  }

  async processAddonPayment(
    addonId,
    { cardHolderFirstName, cardHolderLastName, cardNumber, expiryDate, cvc },
    {
      billingAddressFirstName,
      billingAddressLastName,
      billingAddressEmail,
      billingAddressPhone,
      billingAddressAddressLine1,
      billingAddressCity,
      billingAddressState,
      billingAddressZipCode,
      billingAddressCountry,
    },
    { onSuccess, onError, onDone, onNoBillingAddress, onNoPaymentMethod }
  ) {
    throw new Error("Method 'processAddonPayment(data)' must be implemented.");
  }
}
